import React from "react";
import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";

export const MedicalDisclaimer = ({ variant = "general", className = "" }) => {
  const { t } = useTranslation();
  return (
    <div
      data-testid="medical-disclaimer"
      className={`flex items-start gap-3 rounded-2xl bg-sand px-5 py-4 text-sm leading-relaxed text-deep-ink/70 ${className}`}
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 flex-shrink-0 text-terracotta" aria-hidden="true" />
      <span>{t(`disclaimers.${variant}`)}</span>
    </div>
  );
};
